import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HeaderComponent from "../Header/HeaderComponent";
import MainBanner from "../Banners/MainBanner";
import { useEffect, useRef, useState } from "react";
import {
  fetchTournamentEligibility,
  fetchTournamentPoints,
  fundTransfer,
} from "../../DataStore";
import { connect } from "react-redux";
import axios from "axios";
import {
  IMAGE_BUCKET_URL,
  IMGBUCKETURL,
  TOURNAMENT_DATA_URL,
  TOURNAMENT_URL,
} from "../../DataStore/ApiConstant";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import PromotionInfoPage from "../Promotions/PromotionInfoPage";
import { UserData } from "../../DataStore";
import { promotion } from "../../DataStore/atom";
import { useAtom } from "jotai";
import { usePromotions } from "../../services/promotions";

const BallysTournament = ({
  userData,
  getUserData,
  getFUndTransfers,
  tournamentPoints,
  getTournamentPoints,
  tournamentEligibility,
  getTournamentEligibility,
  openPopup,
  login,
}) => {
  const bottomRef = useRef(null);
  const pageCanvasRef = useRef(null);
  const modalCanvasRef = useRef(null);
  const hasShownTournamentModalRef = useRef(false);
  const tournamentInfoRef = useRef(null);
  const tournamentDataRef = useRef(null);
  const history = useHistory();

  const checkLogin = () => {
    // !sessionStorage.getItem("login") && history.push("/");
    !localStorage.getItem('login') && history.push('/')

  };
  const promotions = usePromotions()
  const [promo, setPromo] = useAtom(promotion);
  const [tournamentData, setTournamentData] = useState(null);
  const [isTournamentModalOpen, setIsTournamentModalOpen] = useState(false);

  const isLoggedIn = Boolean(login) || Boolean(localStorage.getItem("login"));

  const showTournamentFrame =
    isLoggedIn &&
    (Boolean(tournamentEligibility?.eligible) ||
      (Array.isArray(tournamentData?.eligibility) &&
        tournamentData.eligibility.length > 0));

  useEffect(() => {
    if (!isLoggedIn) {
      hasShownTournamentModalRef.current = false;
      setIsTournamentModalOpen(false);
      return;
    }

    const shouldShow = localStorage.getItem("tournament_popup_after_login") === "1";
    if (!shouldShow) return;
    if (!showTournamentFrame) return;
    if (hasShownTournamentModalRef.current) return;

    setIsTournamentModalOpen(true);
    hasShownTournamentModalRef.current = true;
    localStorage.removeItem("tournament_popup_after_login");
  }, [isLoggedIn, showTournamentFrame]);

  const closeTournamentModal = () => {
    setIsTournamentModalOpen(false);
  };

  const getTournamentIdFromResponse = (data) => {
    if (!Array.isArray(data) || data.length === 0) return null;
    const active = data.find((x) => x && x.status === 1 && x.id != null);
    const fallback = data.find((x) => x && x.id != null);
    return (active ?? fallback)?.id ?? null;
  };

  const loadTournamentInfo = async () => {
    try {
      const resp = await axios.get(TOURNAMENT_URL);
      tournamentInfoRef.current = resp?.data ?? null;
      console.log("Tournament Info:", resp?.data);

      const tournamentId = getTournamentIdFromResponse(resp?.data);
      if (tournamentId != null) {
        const tournamentDataResp = await axios.get(
          `${TOURNAMENT_DATA_URL}${tournamentId}`
        );
        const nextTournamentData = tournamentDataResp?.data ?? null;
        tournamentDataRef.current = nextTournamentData;
        setTournamentData(nextTournamentData);
        console.log("Tournament Data:", nextTournamentData);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    checkLogin();
    getUserData();
    getFUndTransfers();
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    getTournamentPoints();
    getTournamentEligibility();
    loadTournamentInfo();
  }, [isLoggedIn]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!showTournamentFrame) return;

    const canvas = (isTournamentModalOpen
      ? modalCanvasRef.current
      : pageCanvasRef.current);
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const container = canvas.parentElement;
    if (!container) return;

    let ambientParticles = [];
    let burstParticles = [];
    let rafId = null;
    let burstIntervalId = null;
    let destroyed = false;

    function resizeCanvas() {
      const nextWidth = container.clientWidth;
      const nextHeight = container.clientHeight;
      if (!nextWidth || !nextHeight) return;
      canvas.width = nextWidth;
      canvas.height = nextHeight;
    }

    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();

    class BoxAmbientParticle {
      constructor() {
        this.reset();
        this.y = Math.random() * canvas.height;
      }
      reset() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + 10;
        this.size = Math.random() * 1.5 + 1;
        this.speedY = Math.random() * -0.8 - 0.2;
        this.speedX = Math.random() * 0.4 - 0.2;
        this.opacity = Math.random() * 0.5 + 0.1;
      }
      update() {
        this.y += this.speedY;
        this.x += this.speedX;
        if (this.y < -10 || this.x < -20 || this.x > canvas.width + 20) {
          this.reset();
        }
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = this.opacity;
        ctx.fillStyle = "#d4af37";
        ctx.shadowColor = "rgba(212, 175, 55, 0.55)";
        ctx.shadowBlur = 8;
        ctx.beginPath();
        if (this.size > 3.5) {
          ctx.rect(this.x, this.y, this.size, this.size);
        } else {
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        }
        ctx.fill();
        ctx.restore();
      }
    }

    class BoxBurstParticle {
      constructor(originX, originY) {
        const angle = Math.random() * Math.PI * 2;
        const speed = Math.random() * 1.8 + 0.6;
        this.x = originX;
        this.y = originY;
        this.vx = Math.cos(angle) * speed;
        this.vy = Math.sin(angle) * speed;
        this.size = Math.random() * 2.2 + 0.8;
        this.opacity = 1;
        this.fade = Math.random() * 0.03 + 0.015;
      }
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += 0.01;
        this.opacity -= this.fade;
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = Math.max(0, this.opacity);
        ctx.fillStyle = "#ffffff";
        ctx.shadowColor = "rgba(243, 224, 155, 0.85)";
        ctx.shadowBlur = 10;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    function initAmbient() {
      const particleCount = 160;
      ambientParticles = Array.from(
        { length: particleCount },
        () => new BoxAmbientParticle()
      );
    }

    function triggerInternalBurst() {
      if (!canvas.width || !canvas.height) return;
      const originX = canvas.width * 0.5 + (Math.random() * 120 - 60);
      const originY = canvas.height * 0.42 + (Math.random() * 80 - 40);
      const count = 18;
      for (let i = 0; i < count; i++) {
        burstParticles.push(new BoxBurstParticle(originX, originY));
      }
    }

    initAmbient();

    function animate() {
      if (destroyed) return;

      if (!canvas.width || !canvas.height) {
        resizeCanvas();
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ambientParticles.forEach((p) => {
        p.update();
        p.draw();
      });

      burstParticles.forEach((p) => {
        p.update();
        p.draw();
      });
      burstParticles = burstParticles.filter((p) => p.opacity > 0);

      rafId = window.requestAnimationFrame(animate);
    }

    rafId = window.requestAnimationFrame(animate);
    burstIntervalId = window.setInterval(() => {
      triggerInternalBurst();
    }, 2600);

    return () => {
      destroyed = true;
      window.removeEventListener("resize", resizeCanvas);
      if (rafId) window.cancelAnimationFrame(rafId);
      if (burstIntervalId) window.clearInterval(burstIntervalId);
    };
  }, [showTournamentFrame, isTournamentModalOpen]);
  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const goToCashier = (type = "deposit") => {
    history.push("/cashier");
    scrollToBottom();
  };
  const userSession = userData?.data?.session

  const submitPoints = async (e) => {
    e?.preventDefault?.();
    if (isLoggedIn) {
      await getTournamentPoints();
    }
  };

  return (
    <>
      {showTournamentFrame && isTournamentModalOpen ? (
        <div
          className="modal show"
          role="dialog"
          aria-modal="true"
          style={{ display: "block", backgroundColor: "#000000a1", zIndex: 1060 }}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeTournamentModal();
          }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content popupBg">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  style={{ backgroundColor: "white" }}
                  onClick={(e) => {
                    e.preventDefault();
                    closeTournamentModal();
                  }}
                />
              </div>
              <div className="modal-body p-0">
                <div className="tournament-frame-box">
                  <svg className="border-svg" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient
                        id="gold-gradient-modal"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="#aa7c11" />
                        <stop offset="30%" stopColor="#f3e09b" />
                        <stop offset="50%" stopColor="#ffffff" />
                        <stop offset="70%" stopColor="#d4af37" />
                        <stop offset="100%" stopColor="#aa7c11" />
                      </linearGradient>
                    </defs>
                    <rect className="border-rect" rx="8" style={{ stroke: "url(#gold-gradient-modal)" }} />
                  </svg>

                  <canvas
                    id="inner-particle-canvas-modal"
                    ref={modalCanvasRef}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  />

                  <div className="content-layer">
                    <div className="mb-3">
                      <span className="suit-icon">♦</span>
                      <span className="suit-icon mx-2">♣</span>
                      <span className="suit-icon">♥</span>
                      <span className="suit-icon mx-2">♠</span>
                    </div>

                    <h3 className="anim-congrats text-uppercase">Congratulations</h3>

                    <p className="anim-selected">YOU HAVE BEEN SELECTED</p>

                    <span className="anim-baccarat m-0">ONLINE BACCARAT TOURNAMENT</span>

                    <div>
                      <span className="anim-year">2026</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div
        className="container tournamentInfoBox mt-lg-5 py-5"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration={1500}
      >
        {showTournamentFrame && (
          <div className="row mb-4">
            <div className="col-12 col-lg-12">
              <div className="tournament-frame-box">
                <svg className="border-svg" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient
                      id="gold-gradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop offset="0%" stopColor="#aa7c11" />
                      <stop offset="30%" stopColor="#f3e09b" />
                      <stop offset="50%" stopColor="#ffffff" />
                      <stop offset="70%" stopColor="#d4af37" />
                      <stop offset="100%" stopColor="#aa7c11" />
                    </linearGradient>
                  </defs>
                  <rect className="border-rect" rx="8" />
                </svg>

                <canvas id="inner-particle-canvas" ref={pageCanvasRef} />

                <div className="content-layer">
                  <div className="mb-3">
                    <span className="suit-icon">♦</span>
                    <span className="suit-icon mx-2">♣</span>
                    <span className="suit-icon">♥</span>
                    <span className="suit-icon mx-2">♠</span>
                  </div>

                  <h3 className="anim-congrats text-uppercase">Congratulations</h3>

                  <p className="anim-selected">YOU HAVE BEEN SELECTED</p>

                  <span className="anim-baccarat m-0">ONLINE BACCARAT TOURNAMENT</span>

                  <div>
                    <span className="anim-year">2026</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <div className="position-relative d-inline-block">
          <img
            src={IMGBUCKETURL + "tournament-banner.jpeg"}
            className="img-fluid mx-auto d-block border border-1"
            alt=""
          />

          <div className="tournamentPointBox">
            {userSession && userSession.username}
            <br />
            <TranslatesContent contentKey="your-tournament-points-in-ballys-tournament" />{" "}
            -{" "}
            <span className="scoreboardNumber">
              <div className="flap-container">
                {String(tournamentPoints?.points || 0)
                  .padStart(6, "0")
                  .split("")
                  .map((digit, index) => (
                    <div
                      key={index}
                      className="flap text-center d-flex align-items-center justify-content-center"
                    >
                      {digit}
                    </div>
                  ))}
              </div>
            </span>
          </div>
        </div> */}

        {/* <div className="row">
          <div className="col-12  mt-4">
            <div className="row">
              <div className="col-12 text-center text-lg-start text-md-start tourDetailsTitel">
                <h1>
                  <TranslatesContent contentKey="tournament-title-in-ballys-tournament" />
                </h1>
                <h2>
                  <TranslatesContent contentKey="tournament-subtitle-in-ballys-tournament" />
                </h2>
              </div>
              <div className="col-12 text-center  tourDetailsText mt-3">
                <h4>
                  <TranslatesContent contentKey="tournament-description-in-ballys-tournament" />
                </h4>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row">
    <div className="col-12  mt-4">
      <div className="row">
        <div className="col-12 text-center text-lg-start text-md-start tourDetailsTitel">
          {/* <h1>BallysBet Online Baccarat Tournament - 2026</h1> */}
          <h1 style={{ textTransform: "capitalize", marginBottom: "15px" }}>
            8 PM ( IST ) On 5th June 2026
          </h1>
          <h2> The Ultimate Battle of Champions Begins!</h2>
        </div>
        <div className="col-12 text-center  tourDetailsText mt-3">
          <h4>
            Get ready to experience the first-ever BallysBet Online Baccarat
            Tournament, where skill, strategy, and determination will compete
            for an incredible prize pool.
            <br />
            <br />
            Qualify through regular gameplay and secure your place among the
            tournament contenders. Compete against the best Baccarat players and
            climb through multiple elimination rounds for a chance to become the
            BallysBet Baccarat Champion.
          </h4>
        </div>
      </div>
    </div>
  </div>
  <div className="row">
    <div className="col-12 text-center text-lg-start mt-4">
      <h1>Tournament Structure</h1>
    </div>
  </div>
  <div className="row g-4 horizontal-pipeline justify-content-center mt-3">
    <div className="col-xl-3 col-lg-3 col-md-6 pipeline-col">
      <div className="card stage-card p-4 d-flex flex-column align-items-start">
        <div
          className="stage-icon-circle text-info"
          style={{ borderColor: "#0dcaf0" }}
        >
          <i className="fa-solid fa-users" />
        </div>
        <span
          className="badge bg-info text-dark mb-2 px-2 py-1 rounded-pill"
          style={{ fontSize: "1rem" }}
        >
          Round 1
        </span>
        <h4 className="fw-bold mb-2 text-light ">Opening Round</h4>
        <p className="text-light small mb-0 flex-grow-1">
          All qualified players will participate in the opening round.
        </p>
      </div>
    </div>
    <div className="col-xl-3 col-lg-3 col-md-6 pipeline-col">
      <div className="card stage-card p-4 d-flex flex-column align-items-start">
        <div className="stage-icon-circle text-primary">
          <i className="fa-solid fa-users" />
        </div>
        <span
          className="badge bg-primary mb-2 px-2 py-1 rounded-pill"
          style={{ fontSize: "1rem" }}
        >
          Round 2
        </span>
        <h4 className="fw-bold mb-2 text-light ">Top 50 Players</h4>
        <p className="text-light small mb-0 flex-grow-1">
          The top 50 players from Round 1 will advance to the second round.
        </p>
      </div>
    </div>
    <div className="col-xl-3 col-lg-3 col-md-6 pipeline-col">
      <div className="card stage-card p-4 d-flex flex-column align-items-start">
        <div
          className="stage-icon-circle"
          style={{ borderColor: "#a855f7", color: "#a855f7" }}
        >
          <i className="fa-solid fa-users" />
        </div>
        <span
          className="badge mb-2 px-2 py-1 rounded-pill"
          style={{ backgroundColor: "#a855f7", fontSize: "1rem" }}
        >
          Round 3
        </span>
        <h4 className="fw-bold mb-2 text-light">Top 30 Players</h4>
        <p className="text-light small mb-0 flex-grow-1">
          The top 30 players from Round 2 will advance to the third round.
        </p>
      </div>
    </div>
    <div className="col-xl-3 col-lg-3 col-md-6 pipeline-col">
      <div className="card stage-card final-stage p-4 d-flex flex-column align-items-start">
        <div className="stage-icon-circle final-icon">
          <i className="fa-solid fa-trophy" />
        </div>
        <span
          className="badge bg-warning text-dark mb-2 px-2 py-1 rounded-pill fw-bold"
          style={{ fontSize: "1rem" }}
        >
          Final Round
        </span>
        <h4 className="fw-bold text-warning mb-2">Top 20 Players</h4>
        <p className="text-light small mb-0 flex-grow-1">
          The top 20 players from Round 3 will compete in the Grand Final for
          the championship title and prize pool distribution.
        </p>
      </div>
    </div>
  </div>
  <div className="row mt-3">
    <div className="col-12 text-center text-lg-start mt-4">
      <h1>Prize Pool</h1>
    </div>
  </div>
  <div className="row g-4 justify-content-center align-items-center mb-5 mt-3">
    <div className="col-lg-4 col-md-6 order-lg-1 order-2">
      <div className="card prize-card rank-2 text-center p-4">
        <div className="display-4 medal-icon mb-2">
          <i className="fa-solid fa-medal" />
        </div>
        <h3 className="h5 text-uppercase fw-bold mb-1 text-white">2nd Place</h3>
        <div className="h2 otp-amount text-light my-2">3,000,000 OTP</div>
        <span className="badge bg-secondary px-3 py-1.5 rounded-pill text-uppercase tracking-wider">
          2nd Place
        </span>
      </div>
    </div>
    <div className="col-lg-4 col-md-12 order-lg-2 order-1">
      <div className="card prize-card rank-1 text-center p-5 transform-scale-lg">
        <div className="display-2 medal-icon mb-2">
          <i className="fa-solid fa-trophy" />
        </div>
        <h2 className="h4 text-uppercase fw-bold text-warning mb-1">
          1st Place
        </h2>
        <div className="display-6 otp-amount text-warning fw-extrabold my-3">
          5,000,000 OTP
        </div>
        <span className="badge bg-warning text-dark px-4 py-2 rounded-pill fw-bold text-uppercase">
          1st Place
        </span>
      </div>
    </div>
    <div className="col-lg-4 col-md-6 order-lg-3 order-3">
      <div className="card prize-card rank-3 text-center p-4">
        <div className="display-4 medal-icon mb-2">
          <i className="fa-solid fa-medal" />
        </div>
        <h3 className="h5 text-uppercase fw-bold mb-1 text-white">3rd Place</h3>
        <div className="h2 otp-amount text-light my-2">2,000,000 OTP</div>
        <span
          className="badge bg-amber px-3 py-1.5 rounded-pill text-uppercase text-white"
          style={{ backgroundColor: "#b45309" }}
        >
          3rd Place
        </span>
      </div>
    </div>
  </div>
  <div className="row justify-content-center">
    <div className="col-lg-8">
      <div className="card runner-up-card p-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          <div className="d-flex align-items-center mb-3 mb-md-0">
            <div className="fs-2 text-info me-3">
              <i className="fa-solid fa-award" />
            </div>
            <div>
              <h4 className="h5 mb-1 fw-bold text-white">4th – 10th Place</h4>
              {/* <p class="text-muted small mb-0">Guaranteed payout for all final table competitors.</p> */}
            </div>
          </div>
          <div className="text-md-end">
            <div className="h3 text-info otp-amount mb-0">
              500,000 OTP <span className="fs-6 text-white">each</span>
            </div>
            {/* <span class="small text-uppercase text-tracking text-muted">OTP Distribution</span> */}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="row mt-3">
    <div className="col-12 text-center text-lg-start mt-4">
      <h1>Winner Selection</h1>
    </div>
  </div>
  <div className="row mt-4">
    <div className="col-12 text-center  tourDetailsText mt-3">
      <h4>
        The final rankings will be determined based on the winning balances
        achieved during the Final Round.
        <br />
        <br />
        Only the Top 10 players in the Final Round will be entitled to receive
        prizes from the tournament prize pool according to their final
        standings.
        <br />
        <br />
        Don't miss your chance to make history and become BallysBet's first
        Baccarat Tournament Champion.
        <br />
        <br />
        Play. Qualify. Compete. Win.
      </h4>
    </div>
  </div>
      </div>
      
<>
  
</>


    </>
  );
};

const maStateTorops = (state) => {
  return {
    fundsTransfer: state.FundTransfers,
    userData: state.userData,
    tournamentPoints: state.TournamentPoints,
    tournamentEligibility: state.TournamentEligibility,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFUndTransfers: () => dispatch(fundTransfer()),
    getUserData: () => dispatch(UserData()),
    getTournamentPoints: () => dispatch(fetchTournamentPoints()),
    getTournamentEligibility: () => dispatch(fetchTournamentEligibility()),
  };
};

export default connect(maStateTorops, mapDispatchToProps)(BallysTournament);
